/* eslint-disable import/no-anonymous-default-export */

import heLabels from './he';
import enLabels from './en';

export default {
    he: heLabels,
    en: enLabels,
};